import { render, staticRenderFns } from "./OrdersAndScheduleTable.vue?vue&type=template&id=15262726"
import script from "./OrdersAndScheduleTable.vue?vue&type=script&lang=js"
export * from "./OrdersAndScheduleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports